import React from 'react'
import CustomButton from '../shared/customButton/CustomButton';
import { setSelectedSearchBoxTab } from '../redux/actions/homeActions';
import { useHistory } from 'react-router';
import { useAppDispatch } from '../redux/hooks';
import heroImage from './../assets/images/heroImage3.webp';
import {Helmet} from "react-helmet-async";

const questions = [
  {
    question: 'Where can I travel on the National Rail?',
    answer: <p>You can travel with the following 25 train companies in Great Britain (England, Scotland and Wales): Arriva Trains Wales, Avanti West Coast, c2c, Caledonian Sleeper, Chiltern Railways, CrossCountry, East Midlands Railway, Eurostar, Gatwick Express, Grand Central Railway, Great Northern, GWR, Greater Anglia, Heathrow Express, Hull Trains, Island Line, London Overground, London North Eastern Railway, London Northwestern Railway, Merseyrail, Northern, ScotRail, South Western Railway, Southeastern, Southern, Stansted Express, TfL Rail, Thameslink, TransPennine Express, Transport for Wales.</p>
  },
  {
    question: 'How do I buy National Rail tickets?',
    answer: <p>You can <a href="/">buy National Rail tickets on our website.</a> Rail Online is an accredited partner of the Rail Delivery Group.</p>
  },
  {
    question: 'What if I need to change my booking?',
    answer: <p>You can change the date and time of your advance tickets up to 6pm the day before travel</p>
  },
  {
    question: 'Why should I book my National Rail tickets with you?',
    answer: <p>You can save over 60% on the average price of same-day train tickets by booking in advance on our website. We offer great deals and don’t charge booking fees. Our website is easy to use and our customer support team are here if you need them.</p>
  },
  {
    question: 'What is the difference between a train ticket and a rail pass?',
    answer: <p>A train ticket is for a single journey between two locations. The ticket is valid for a specific train on a specific date at a specific time. A rail pass allows you to travel across a defined geographical area and can include multiple countries. You can travel across that area as much as you like during a set time frame.</p>
  },
  {
    question: 'What is a Railcard?',
    answer: <p>A Railcard is a card you hold in addition to your train ticket. You use your Railcard when you buy train tickets to save money on your fare. You must have your Railcard with you at all times to get the discount. There are different types of Railcard for different ages and groups.</p>
  },
  {
    question: 'What is the cancellation penalty for UK Rail Tickets?',
    answer: <p>Advance fares incur 100% cancellation fee making the tickets non-refundable. Off-Peak and Anytime fares can be cancelled. If you choose to cancel your journey entirely, for a reason other than delay or cancellation, you can get a refund, but you may be charged an admin fee of no more than £5 per ticket.</p>
  },
  {
    question: 'What if my train has been cancelled?',
    answer: <ul>
      <li>If your train is cancelled, and you have an Advance fare, you can travel on one of the two services immediately after the original cancelled service, or one of the two services prior to the original cancelled service at no extra cost. It is advisable to carry confirmation of your original booked cancelled service when travelling in case questioned.</li>
      <li>If your train is cancelled, and you have an Off-Peak fare, you can travel on one of the two services immediately after the original cancelled service, or one of the two services prior to the original cancelled service, or any applicable Off Peak train (depending on route restrictions) at no extra cost. It is advisable to carry confirmation of your original booked cancelled service when travelling in case questioned.</li>
      <li>If your train is cancelled and you have an Anytime fare, these fares provide greater flexibility. You can travel on one of the two services immediately after the original cancelled service, or one of the two services prior to the original cancelled service, or any applicable train (depending on route restrictions) at no extra cost. It is advisable to carry confirmation of your original booked cancelled service when travelling in case questioned.</li>
    </ul>
  }, 
  {
    question: 'What if my train is cancelled and I then miss my connection?',
    answer: <p>Where possible, the Train Operating Companies allow for flexibility on missed connections if your original train has been cancelled. However, it is advised to always check with the Train Operating Company before you travel.</p>
  }, 
  {
    question: 'What happens if the alternative train services are not convenient, and I choose not to travel?',
    answer: <p>If you no longer wish to travel, your ticket is refundable if the train has been cancelled. Please contact Rail Online with 28 days of train departure via email <a href="mailto:info@rail.online">info@rail.online</a> for further information</p>
  }, 
]

function NationalRailPage() {
  const history = useHistory();
  const dispatch = useAppDispatch();

  return (
    <>
      <Helmet>
        <title>Rail Online - Buy Cheap Train Tickets in UK & Europe Online</title>
        <meta name="description" content="Rail Online is a quick & easy way to book cheap train tickets across UK & Europe. Take the scenic route with terrific deals on train tickets." />
        <link rel="canonical" href="https://www.rail.online/uk-rail-tickets"/>
      </Helmet>
      <div className="hero-image-container">
        <div className="background-shade d-none d-md-flex opacity-change"></div>
        <img className="img-fluid hero-image d-none d-md-flex" src={heroImage} alt="heroImage" />
        <div className="about-us-page--title">
          <h1>National Rail</h1>
          <h2>Save on your UK train tickets by booking in advance.</h2>
        </div>
      </div>
      <div className="container-fluid max-width mb-5">
        <div className="common-page">
          <div className="common-page--content-area max-width about-us-page">
            <p>
              National Rail is run by the Rail Delivery Group (RDG) – a group of companies that run Britain’s rail network. Rail Online is accredited by RDG to provide you with tickets, timetables and information for the UK rail network. When you book your National Rail tickets on our website, you can save over 60% on the average price of same-day train tickets. Our user-friendly booking engine allows you to plan, book and manage rail bookings from all of RDG’s 25 train operating companies. That includes railcards and off-peak tickets.
            </p>

            <h3 className="mt-5 mb-3 text-left">Frequently Asked Questions</h3>

            {
              questions.map(({ question, answer }) => (
                <div key={question} className="qa-box">
                  <div className="qa-box--header">
                    <h4 className="p-2 p-md-3 pt-3 pb-3">{question}</h4>
                  </div>
                  <div className="p-2 p-md-3">{answer}</div>
                </div>
              ))
            }

            <h3 className="mt-5 mb-4">Ready to save on UK train tickets?</h3>
            <div className="d-flex w-100 justify-content-center">
              <CustomButton
                text="BOOK A TRIP"
                className="go-btn"
                onClick={() => {
                  dispatch(setSelectedSearchBoxTab('Train Tickets'));
                  history.push('/')
                }} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default NationalRailPage
